import React from "react";
import "./TargetAudienceSection.css";

const TargetAudienceSection = () => {
  return (
    <section id="partners" className="target-audience-section">
      <div className="audience-container">
        <h2 className="audience-title">Pensé pour vous</h2>

        <div className="audience-cards">
          {/* Startups Card */}
          <div className="audience-card">
            <div className="card-header">
              <div className="icon-container">
                <img src="/icons/rocket.svg" alt="Rocket" />
              </div>
              <div className="card-title-group">
                <h3 className="card-title">Startups</h3>
                <p className="card-subtitle">Lancement Rapide</p>
              </div>
            </div>
            <p className="card-description">
              Vous avez la vision, nous la concrétisons rapidement et
              proprement, avec agilité et qualité.
            </p>
          </div>

          {/* PME Card */}
          <div className="audience-card">
            <div className="card-header">
              <div className="icon-container">
                <img src="/icons/building.svg" alt="Building" />
              </div>
              <div className="card-title-group">
                <h3 className="card-title">PME Ambitieuses</h3>
                <p className="card-subtitle">Croissance Sereine</p>
              </div>
            </div>
            <p className="card-description">
              Nous apportons les ressources techniques et stratégiques pour
              évoluer sereinement, sans freins technologiques.
            </p>
          </div>

          {/* Solo & TPE Card */}
          <div className="audience-card">
            <div className="card-header">
              <div className="icon-container">
                <img src="/icons/user.svg" alt="User" />
              </div>
              <div className="card-title-group">
                <h3 className="card-title">Solo & TPE</h3>
                <p className="card-subtitle">Sur-Mesure Digital</p>
              </div>
            </div>
            <p className="card-description">
              Nous créons des outils adaptés à vos besoins spécifiques pour vous
              faire gagner en efficacité et en visibilité.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudienceSection;
